<template lang="pug">
  v-app-bar.appbar-styles(
      app
      color="accent"
      dense
      dark
      height="72"
    )
      v-toolbar-title(class="d-flex")
        img(class="brand-logo" src="@/assets/yellowlogo.png")
      v-toolbar-items
        v-btn.no-button-outline(
          icon
          @click="goback"
        )
          v-icon mdi-home
        v-badge(
          :color="cartCount ? 'blue lighten-1' : 'transparent'"
          :content="cartCount ? cartCount : ''"
          overlap
          offset-y="25"
          offset-x="20"
          class="d-flex"
        )
          v-btn.no-button-outline(
            class="m-auto"
            icon
            @click="openCart"
          )
            v-icon mdi-cart
        v-btn.no-button-outline(
          icon
          @click="openOrder"
        )
          v-icon mdi-clipboard-text
</template>

<script>
export default {
  computed: {
    cartCount() {
      return this.$store.getters.dinein.order_list.length;
    }
  },
  methods: {
    goback() {
      this.$emit("close");
    },
    openCart() {
      this.$emit("openCart");
    },
    openOrder() {
      this.$emit("openOrder");
    }
  }
};
</script>
